import * as React from "react";
import styled, { css } from "styled-components";
import * as _ from "lodash";
import { Options, Chart } from "highcharts";
import { observer } from "mobx-react";

const ReactHighcharts = require("react-highcharts");

const QwiltHighchartView = styled.div`
  ${(props: {}) => css`
    height: 100%;
    width: 100%;
  `};
`;

export interface Props {
  chartConfig: Options;
  className?: string;
  chartReadyCallback?: (chart: Chart) => void;
}

const initialState = { sizeKnown: false, width: 0, height: 0 };

type State = Readonly<typeof initialState>;

@observer
export class QwiltHighchart extends React.Component<Props, State> {
  static defaultProps = {};
  readonly state: State = initialState;

  viewRef = React.createRef<HTMLElement>();
  chartRef = React.createRef<{ getChart: () => Chart }>();

  onResize = () => {
    const viewDOM = this.viewRef.current;
    let chartRef = this.chartRef.current;

    if (viewDOM && chartRef) {
      chartRef.getChart().setSize(viewDOM.offsetWidth, viewDOM.offsetHeight);
      chartRef.getChart().redraw(false);
      chartRef.getChart().reflow();
    }
  };

  componentDidMount() {
    const viewDOM = this.viewRef.current!;
    window.addEventListener("resize", this.onResize, false);
    this.setState({ sizeKnown: true, height: viewDOM.offsetHeight, width: viewDOM.offsetWidth });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize, false);
  }
  componentDidUpdate() {
    const viewDOM = this.viewRef.current;
    if (viewDOM && viewDOM.offsetWidth !== this.state.width) {
      this.setState({ width: viewDOM.offsetWidth });
      this.onResize();
    }
  }
  render() {
    let highcharts = undefined;
    if (this.state.sizeKnown) {
      const configClone = _.cloneDeep(this.props.chartConfig);
      configClone.chart = { ...configClone.chart, height: this.state.height, width: this.state.width } as any;
      highcharts = (
        <ReactHighcharts
          ref={this.chartRef}
          isPureConfig={true}
          config={configClone}
          callback={this.props.chartReadyCallback}
        />
      );
    }

    return (
      <QwiltHighchartView ref={this.viewRef as any} className={this.props.className}>
        {highcharts}
      </QwiltHighchartView>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/qwiltHighchart/QwiltHighchart.tsx